(function (angular, schoolwork12) {

    'use strict';
    angular.module(schoolwork12.app.graduationPlan.name)
      .controller(schoolwork12.app.graduationPlan.controllers.addSchoolPlan, [
        '$rootScope', '$scope', '$timeout', '$http', '$uibModal', '$location', '$q', '$anchorScroll',
         schoolwork12.app.auth.services.authentication,
         schoolwork12.app.common.services.eventNotification,
         schoolwork12.app.graduationPlan.services.graduationPlanSvc,
        function ($rootScope, $scope, $timeout, $http, $uibModal, $location, $q, $anchorScroll,
            authentication, eventNotification, graduationPlanSvc) {

            console.info("In add school plan controller");
            eventNotification.subscribe(schoolwork12.app.auth.events.userLoggedIn,
                function (event, authenticatedUser) {
                    console.info('Add School Plan controller: Subscribe On UserLogin Event: '
                        .concat(angular.toJson(authenticatedUser)));

            });

            //display error message for duplicate cohort year
            $scope.getCohortError = function(cohort){
                return cohort<0? '(-) '+(-cohort) : '(+) '+cohort;
            }
            
            $scope.forms={};
            $rootScope.hideManageGradPlan = true;
            $scope.isSearchBusy = false;
            $rootScope.showSavedSuccessMsg = false;
            $rootScope.showPartialWarningMsg = false;

            $scope.validateDiploma=false;
            $scope.validateGradPlan=false;
            $scope.validateAddReq=false;
            
            //<!--alert dialog for leaving page without saving
            $scope.option1 = false;
            $scope.modalInstance1 = null;
            $rootScope.$on('$stateChangeStart', function(event, next, current) {
                
                if ($rootScope.showSavedSuccessMsg && !$rootScope.closeSuccess){
                    $timeout( function() { 
                        $rootScope.showSavedSuccessMsg = false;
                    }, 7000);
                }

                if ($rootScope.showPartialWarningMsg || !$rootScope.closeWarning){
                    $timeout( function() { 
                        $rootScope.showPartialWarningMsg = false;
                    }, 7000);
                }

                if($scope.forms.Diploma){
                    if($scope.forms.Diploma.$dirty || $scope.forms.GradPlan.$dirty || $scope.forms.AddRequirement.$dirty){
                        if(!$scope.option1){
                            $scope.openAlertUnsaved();
                            event.preventDefault(); 
                            $rootScope.hideManageGradPlan = true;
                        }
                        
                        $scope.modalInstance1.result.then(function (option) {
                            $scope.option1 = option;
                            $location.url(next.url);
                        }, function () {
                        });
                    }
                }
            })
            
            $scope.openAlertUnsaved = function () {
                $scope.modalInstance1 = $uibModal.open({
                    animation: $scope.animationsEnabled,
                    templateUrl: 'commonDialog.html',
                    windowClass: 'alert-Modal',
                    keyboard: false,
                    backdrop: 'static',
                    controller: ['$scope', '$uibModalInstance',
                    function ($scope, $uibModalInstance) {
                        $scope.ok = function () {
                            $uibModalInstance.close(true);
                        };

                        $scope.dialogMsg = 'You have un-saved changes on this page. Do you want to leave this page without saving the changes?';
                        $scope.cancel = function () {
                            $uibModalInstance.dismiss('cancel');
                        };
                    }], 
                    
                });
            };
            //-->

            // partial save initialise warning
            $scope.showPartialWarningError = function(){
                $scope.forms.Diploma.$setPristine();
                $scope.forms.GradPlan.$setPristine();
                $scope.forms.AddRequirement.$setPristine();

                $rootScope.showPartialWarningMsg = true;
                $rootScope.closeWarning = false;
                $location.url('/manage-school-graduation-plans');
            }    
            
            //<!-- disable select school drop down list when users start to add subject
            $scope.disableSchoolSelection = false;
            $scope.changeSubject = function(subject){
                if(!$scope.disableSchoolSelection){
                    $scope.disableSchoolSelection = true;
                }
                
                if(angular.isDefined(subject.credits)){
                    subject.credits = 0.0;
                }
                
                if(angular.isDefined(subject.creditRequired)){
                    subject.creditRequired = 0.0;
                }
            }
            
            $scope.credit_focus = function(subject){
                if(subject.credits==0){
                    subject.credits = '';
                }
                if(subject.creditRequired==0){
                    subject.creditRequired = '';
                }
            }
           
            $scope.credit_blur = function(subject){
               if(subject.credits=='' || subject.credits==null){
                   subject.credits = 0;
               }
               if(subject.creditRequired=='' || subject.creditRequired==null){
                   subject.creditRequired = 0;
               }
            }

            $scope.locationScroll = function(){
              $location.hash('pageTop');
              $anchorScroll();
              $location.hash('');
            }

            $scope.gotoStep1 = function() {
              $scope.addPlanSteps.step1=!$scope.addPlanSteps.step1;  
              $scope.locationScroll();
            };

            // logic to conditionally call courses service
            $scope.courseFlag = false;
            $scope.setCourses = function() {
                $scope.courseFlag = true;
            }

            $scope.gotoStep2 = function() {
              $scope.addPlanSteps.step2=!$scope.addPlanSteps.step2;  
              $scope.courseFlag = true;
              $scope.locationScroll();
            };

            // get categories for additional requirements
            $scope.gotoStep3 = function() {
              $scope.addPlanSteps.step3=!$scope.addPlanSteps.step3;  
              if (!$scope.categories){
                $scope.getAddReqCategories();
              }
              $scope.locationScroll();
            };
            
            //<!-- change subjectlist when school is change
            $scope.$watch('[diplomaDetails.school, courseFlag]', function(newValue, oldValue){
                $scope.getSubjectsBySchool();
            }, true);
            // -->
            
            //<!-- invoke rest service to change subjectlist
            $scope.addGradPlanErrorOccurred = false;
            $scope.sameDiplomaNameError = false;

            $scope.subjectFields = [];
            $scope.subjectFieldsWithCourses = [];
            $scope.getSubjectsBySchool = function(){
                var getSubjectsBySchoolPromise = null;
                var getSubjectsBySchoolSvc = function(){
                    getSubjectsBySchoolPromise =  graduationPlanSvc.getSubjectsBySchool(authentication.getCurrentUser().keycode,$scope.diplomaDetails.school.schoolId, $scope.courseFlag);
                    getSubjectsBySchoolPromise.then(function (data) {    
                        console.info("Providing list of related subject");   
                        if(!$scope.courseFlag)
                           $scope.subjectFields = data.schoolSubjectList.sort(function(a, b) {
                            return a.name > b.name ? 1 : -1;
                        });
                       
                        else{
                           $scope.subjectFieldsWithCourses = data.schoolSubjectList;
                           if(!$scope.disableSchoolSelection)
                        	   $scope.subjectFields = data.schoolSubjectList.sort(function(a, b) {
                                   return a.name > b.name ? 1 : -1;
                               });
                              
                        }
                    }, function (error) {
                        console.info('Error in getting subjectlist....'.concat(angular.toJson(error)));   
                        $scope.addGradPlanErrorOccurred = true;
                        if (error.status == 400) {
                            for ( var j = 0; j < error.data._errors.length; j++) {
                                $scope.addGradPlanErrorMesg = $scope.addGradPlanErrorMesg + error.data._errors[j] + "\n" + "\n";
                            }
                        } else if (error.status == 401 || error.status == 403) {
                            $scope.addGradPlanErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                        } else {
                            $scope.addGradPlanErrorMesg = schoolwork12.app.errorMessages.internalError;
                        }
                    });
                };
                
                if (typeof (authentication.getCurrentUser()) != 'undefined' && authentication.getCurrentUser() != null) {
                    console.info('Keycode found. Making a call to service');
                    getSubjectsBySchoolSvc();
                } else {
                    console.info('Key code not found. Using time out function to make a call');
                    $timeout(function () {
                    getSubjectsBySchoolSvc();
                    }, 500);
                };
            };
            // -->

            // changes for Accordion
            $scope.oneAtATime = true;
            $scope.addPlanSteps = { step1: true, step2: false, step3: false, opened: true};
            
            //newly Added - Subject Criteria           
            $scope.defaultSubject = {option: null, credits: 0.0 ,status: 1, subjectCriteria: null, index: 0};
    
            $scope.gradReqs = [$scope.defaultSubject];
            //newly Added - Subject Criteria End
            //$scope.gradReqs = [{option: null, credits: 0.0 ,status: 1}];
                      
            $scope.diplomaDetails = {
                diplomaName : '',
                school : '',
                default : true
            };

            $scope.diplomaDetails.school = $rootScope.selectedGradPlanSchool;
            //newly Added - Subject Criteria                           
            $scope.addSubjectSummary = function(){
                $scope.forms.Diploma.$setDirty();
                var length = $scope.gradReqs.length;
                var index = 0;
                if(length != 0){
                    index = $scope.gradReqs[length-1].index+1;
                }
                $scope.gradReqs.push({option: null, credits: 0.0 ,status: 1, subjectCriteria: null, index: index});
            };
                                       
            $scope.removeSubjectSummary = function(index){
                $scope.forms.Diploma.$setDirty();
                $scope.gradReqs.splice(index,1);
            };
            
            $scope.termspyr = [1,2,3,4];
            $scope.termDetails = {
                termspyr : '2',
                terms : [
                    {name: ''},
                    {name: ''}
                ]
            };

            //NgTagsInput Start
            $scope.allTagsAdded = [];
            $scope.loadTags = function ($query) {
                $query = $query.trim();
                var defer = $q.defer();
                graduationPlanSvc.getSchoolTerms(authentication.getCurrentUser().keycode).then(function (data, status, headers, config) {
                    //console.info(angular.toJson(data));
                    var matchingTags = data.schoolTermList;                    
                    if($scope.allTagsAdded.length > 0){
                        matchingTags = $scope.removeDuplicatesTags(matchingTags);                         
                    }                    
                    if ($query.length >= 1) {
                        matchingTags = matchingTags.filter(function (item) {
                            return item.name.toLowerCase().indexOf($query.toLowerCase()) != -1;
                        });                       
                        if (matchingTags.length <= 0) {
                                matchingTags = [{
                                    "name": "Oops, nothing found! " + "'" + $query + "'"
                                }];
                        }
                    }
                defer.resolve(matchingTags);
               },
               function (data, status, headers, config) {
                console.error("ERROR OCCURRED");
               });
            return defer.promise;
          };
            
        $scope.removeDuplicatesTags = function(tagsArray){
            for(var i=0, len = $scope.allTagsAdded.length; i<len; i++){
                for(var j=0, length= tagsArray.length; j<length; j++){
                    if(tagsArray[j].name.toLowerCase() == $scope.allTagsAdded[i].name.toLowerCase()){
                        tagsArray.splice(j,1);
                        break;
                    }        
                }            
            }
            return tagsArray;
        };
            
        $scope.tagAdded = function(tag, termArray){ 
            if (tag.name.indexOf("Oops, nothing found!") !== -1) {
                termArray.pop(tag);                   
            } else {
            	$scope.allTagsAdded.push(tag);
            }
        };
            
        $scope.tagRemoved = function(tag){
            $scope.allTagsAdded = $scope.allTagsAdded.filter(function(item){
                return item.name.toLowerCase() !== tag.name.toLowerCase();
            });
        };
        //NG-TAGS-INPUT END

            $scope.refreshValidation = function(){
                for(var i=0; i<$scope.termDetails.terms.length; i++){
                    if($scope.forms.GradPlan['termName_'+i].$error.duplicateName){
                        var isDuplicate = true;
                        for(var j=0; j<$scope.termDetails.terms.length; j++){
                            if(i==j)
                                continue;
                            if(angular.isDefined($scope.termDetails.terms[i].name) && angular.isDefined($scope.termDetails.terms[j].name) && $scope.termDetails.terms[i].name.toLowerCase() == $scope.termDetails.terms[j].name.toLowerCase()){
                                isDuplicate = false;
                            }
                        }
                        if(isDuplicate)
                            $scope.forms.GradPlan['termName_'+i].$setValidity('duplicateName',true);
                    }
                }
            }
            $scope.changeTermPYear = function(oldValue){
                var newValue = $scope.termDetails.termspyr;
                if(newValue>$scope.termDetails.terms.length){
                    for(var i=0;i<newValue-oldValue;i++)
                        $scope.termDetails.terms.push({name:''});
                    for(var i=0;i<$scope.yearPlans.length;i++){
                        var diff = newValue - $scope.yearPlans[i].terms.length;
                        for(var j=0;j<diff;j++){
                            var length = $scope.yearPlans[i].terms.length;
                            var index = 0
                            if(length != 0){
                                index = $scope.yearPlans[i].terms[length-1].index+1;
                            }
                            $scope.yearPlans[i].terms.push({     
                                items:[{subject: '', course: '', creditRequired: 0.0, index: 0}],
                                index : index
                            });
                        }
                    }
                }
                if(newValue<$scope.termDetails.terms.length){
                    $scope.openReduceTerms('lg');
                    
                    $scope.termDetails.termspyr = oldValue;
                    
                    $scope.modalInstance2.result.then(function (option) {
                        if(option){
                            $scope.termDetails.termspyr = newValue;
                                
                            var diff = oldValue-newValue;
                            for(var i=newValue;i<oldValue;i++){
                                angular.forEach($scope.termDetails.terms[i].termMapping,function(termMap){
                                    $scope.allTagsAdded = $scope.allTagsAdded.filter(function(item){
                                        return item.name.toLowerCase() !== termMap.name.toLowerCase();
                                    });
                                });
                            }
                            $scope.termDetails.terms.splice($scope.termDetails.terms.length-diff,diff);
                            
                            for(var i=0;i<$scope.yearPlans.length;i++){
                                diff = $scope.yearPlans[i].terms.length-newValue;
                                $scope.yearPlans[i].terms.splice($scope.yearPlans[i].terms.length-diff,diff);
                            }
                        }
                        $scope.refreshValidation();
                    }, function () {
                    });
                }
            }
            //prompt before reduce number of terms
            $scope.modalInstance2 = null;
            $scope.openReduceTerms = function (size) {
                $scope.modalInstance2 = $uibModal.open({
                    animation: $scope.animationsEnabled,
                    templateUrl: 'commonDialog.html',
                    size: size,
                    keyboard: false,
                    backdrop: 'static',
                    controller: ['$scope', '$uibModalInstance',
                    function ($scope, $uibModalInstance) {
                        $scope.ok = function () {
                            $uibModalInstance.close(true);
                        };

                        $scope.dialogMsg = 'Reducing the number of terms will remove the last term from the Term Details and Year Details sections of your graduation plan. Do you want to continue?';
                        $scope.cancel = function () {
                            $uibModalInstance.close(false);
                        };
                    }], 
                    
                });
            };
            //
            
            $scope.changeTermName = function (index, oldValue) {
                var countOld = 0;
                var idxOld = -1;
                
                $scope.forms.GradPlan['termName_'+index].$setValidity('duplicateName',true);
                for(var i=0; i<$scope.termDetails.terms.length; i++){
                    if(i==index)
                        continue;
                    if(angular.isDefined($scope.termDetails.terms[i].name) && angular.isDefined($scope.termDetails.terms[index].name) && $scope.termDetails.terms[index].name.length!=0 && $scope.termDetails.terms[index].name.toLowerCase() == $scope.termDetails.terms[i].name.toLowerCase() ){
                        $scope.forms.GradPlan['termName_'+index].$setValidity('duplicateName',false);
                    }
                    
                    if(angular.isDefined(oldValue) && angular.isDefined($scope.termDetails.terms[i].name) && $scope.termDetails.terms[i].name.toLowerCase() == oldValue.toLowerCase()){
                        countOld++;
                        idxOld = i;
                    }
                }
                if(countOld==1){
                    $scope.forms.GradPlan['termName_'+idxOld].$setValidity('duplicateName',true);
                }
            }
            // Subject Criteria set up
            $scope.addSubjectCriteria = function(allSubjects, selectedSubject){                
                var modalInstance = $uibModal.open({
                    templateUrl: schoolwork12.app.graduationPlan.templates.subjectCriteriaModal,
                    size: 'lg',
                    keyboard: false,
                    backdrop: 'static',                   
                    resolve: {
                        allSubjects: function() {
                            return allSubjects;
                        },
                        selectedSubject: function() {
                            return selectedSubject;
                        }
                    },
                    controller : schoolwork12.app.graduationPlan.controllers.subjectCriteria                  
                });
                modalInstance.result.then(function (option) {
                    selectedSubject.subjectCriteria = option;                    
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                });
                
            };                      
            
            $scope.removeSubjectCriteria = function(subject){              
              subject.subjectCriteria = null;
            };
            //Subject Criteria End
            
            //prompt before removing a year from the plan
            $scope.openRemoveYear = function (idx) {
                var modalInstance = $uibModal.open({
                    animation: $scope.animationsEnabled,
                    templateUrl: 'commonDialog.html',
                    size: 'lg',
                    keyboard: false,
                    backdrop: 'static',
                    controller: ['$scope', '$uibModalInstance',
                    function ($scope, $uibModalInstance) {
                        $scope.ok = function () {
                            $uibModalInstance.close(true);
                        };
              
                        $scope.dialogMsg = 'Removing the year from the plan will result in the removal of all associated course setup for the year\'s terms. Do you want to continue?';
                        $scope.cancel = function () {
                            $uibModalInstance.close(false);
                        };
                    }]
                });
                
                modalInstance.result.then(function (option) {
                    if(option){
                        // console.log(idx);
                        $scope.deleteYearPlan(idx);
                    }
                }, function () {
                });
            };
            //
            
            $scope.yearPlans = [
                {
                    name: '', Cohort: '-3', index: 0,
                    terms: [
                        {     
                            items:[{subject: '', course: '', creditRequired: 0.0, status: 1, index: 0}],
                            index: 0
                        },
                        {
                            items:[{subject: '', course: '', creditRequired: 0.0, status: 1, index: 0}],
                            index: 1
                        }
                    ]
                }
            ];
                  
            $scope.additionReqs = [
                {required: false, category: '', rename: '', comments: '', index: 0}
            ];
                                      
            $scope.addSubjectPlan = function(parIdx, curIdx){
                //console.log(parIdx+'/'+curIdx);
                $scope.forms.GradPlan.$setDirty();
                var length = $scope.yearPlans[parIdx].terms[curIdx].items.length;
                var index = 0;
                if(length != 0){
                    index = $scope.yearPlans[parIdx].terms[curIdx].items[length-1].index+1;
                }
                $scope.yearPlans[parIdx].terms[curIdx].items.push({subject: '', course: '', creditRequired: 0.0, index: index});
            };
                                   
            $scope.removeSubjectPlan = function(ancIdx, parIdx, curIdx){
                //console.log(ancIdx+'/'+parIdx+'/'+curIdx);
                $scope.forms.GradPlan.$setDirty();
                $scope.yearPlans[ancIdx].terms[parIdx].items.splice(curIdx,1);
            };
                                      
           $scope.addCategory = function(){
               $scope.forms.AddRequirement.$setDirty();
               var length = $scope.additionReqs.length;
               var index = 0;
               if(length != 0){
                   index = $scope.additionReqs[length-1].index+1;
               }
               $scope.additionReqs.push({required: false, category: '', rename: '', comments: '', index: index});
           };
                                     
           $scope.removeCategory = function(idx){
               $scope.forms.AddRequirement.$setDirty();
               $scope.additionReqs.splice(idx,1);
           };
            
            $scope.addYearPlan = function(){
                $scope.forms.GradPlan.$setDirty();
                var year = 0;
                if($scope.yearPlans.length == 0)
                    year = 1;
                else
                    year = $scope.yearPlans[$scope.yearPlans.length-1].year+1;
                
                var length = $scope.yearPlans.length;
                var index = 0;
                if(length != 0){
                    index = $scope.yearPlans[length-1].index+1;
                }
                $scope.yearPlans.push(
                    {
                        name: '', Cohort: '-3',
                        terms: [],
                        index: index
                    }
                );
                
                for(var i=0;i<$scope.termDetails.termspyr;i++){
                    $scope.yearPlans[$scope.yearPlans.length-1].terms.push({
                        items:[{subject: '', course: '', creditRequired: 0.0, index: 0}],
                        index: i
                    });
                }
            };
                                 
            $scope.deleteYearPlan = function(idx){
                $scope.forms.GradPlan.$setDirty();
                $scope.yearPlans.splice(idx,1);
            }
            
            $scope.calcSumCredits = function(){
                var total = 0;
                var fix = 0;
                angular.forEach($scope.gradReqs,function(subject){
                    if(angular.isNumber(subject.credits)){
                        var decimal = null;
                        if((''+subject.credits).includes('.'))
                            decimal = (''+subject.credits).split('.')[1];
                        if(decimal!=null && decimal.length){
                            if(decimal.length > fix){
                                fix = decimal.length;
                            }
                        }
                        if(subject.credits){
                            total = total + subject.credits;
                        }
                    }
                });
                total = total.toFixed(fix);
                return total;      
            }

            $scope.getAddReqCategories = function(){
                var getCategoriesPromise = null;
                var getCategoriesSvc = function(){
                    getCategoriesPromise =  graduationPlanSvc.getAddRequirementCategories(authentication.getCurrentUser().keycode);
                    getCategoriesPromise.then(function (data) {    
                        console.info("Providing list of categories");
                        console.log(data);
                        $scope.categories = data;
                    }, function (error) {
                        console.info('Error in getting categries list....'.concat(angular.toJson(error)));   
                        $scope.addGradPlanErrorOccurred = true;
                        if (error.status == 400) {
                            for ( var j = 0; j < error.data._errors.length; j++) {
                                $scope.addGradPlanErrorMesg = $scope.addGradPlanErrorMesg + error.data._errors[j] + "\n" + "\n";
                            }
                        } else if (error.status == 401 || error.status == 403) {
                            $scope.addGradPlanErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                        } else {
                            $scope.addGradPlanErrorMesg = schoolwork12.app.errorMessages.internalError;
                        }
                    });
                };
                
                if (typeof (authentication.getCurrentUser()) != 'undefined' && authentication.getCurrentUser() != null) {
                    console.info('Keycode found. Making a call to service');
                    getCategoriesSvc();
                } else {
                    console.info('Key code not found. Using time out function to make a call');
                    $timeout(function () {
                    getCategoriesSvc();
                    }, 500);
                };
            }
            
            //<!-- invoke rest service to save diploma
            $scope.addGradPlanErrorOccurred = false;
            $scope.addGradPlanErrorMesg = '';
            $scope.saveSchoolDiploma = function(){
                var saveSchoolDiplomaPromise = null;
                $scope.addGradPlanErrorMesg = '';
                var saveSchoolDiplomaSvc = function(){
                    var data = {
                        diploma: {}
                    };
                    var details = {
                        name: $scope.diplomaDetails.diplomaName,
                        schoolId: $scope.diplomaDetails.school.schoolId,
                        status: 1
                    };
                    var subjects = [];
                    angular.forEach($scope.gradReqs,function(item){
                        var subject = {
                            name: item.option.name,
                            credits: item.credits,
                            status : 1
                        };
                        if(angular.isDefined(item.option.schoolSubjectId)){
                            subject.schoolSubjectId = item.option.schoolSubjectId;
                        }
                        else if(angular.isDefined(item.option.k12SubjectId)){
                            subject.k12SubjectId = item.option.k12SubjectId;
                        }
                        
                        if(item.subjectCriteria!=null && item.subjectCriteria.subjectCriteriaList.length != 0){
                            subject.condition = item.subjectCriteria.logicalOperation;
                            subject.subSubjects = [];
                            angular.forEach(item.subjectCriteria.subjectCriteriaList, function(sub){
                                var subCrit = {
                                    name: sub.option.name,
                                    credits: sub.credits,
                                    status : 1
                                };
                                if(angular.isDefined(sub.option.schoolSubjectId)){
                                    subCrit.schoolSubjectId = sub.option.schoolSubjectId;
                                }
                                else if(angular.isDefined(sub.option.k12SubjectId)){
                                    subCrit.k12SubjectId = sub.option.k12SubjectId;
                                }
                                subject.subSubjects.push(subCrit);
                            });
                        }
                        subjects.push(subject);
                    });
                    data.diploma.details = details;
                    data.diploma.subjects = subjects;
                    
                    saveSchoolDiplomaPromise = graduationPlanSvc.saveSchoolDiploma(authentication.getCurrentUser().keycode, $scope.diplomaDetails.school.schoolId, data);
                    var saveSchoolDiplomaChain = saveSchoolDiplomaPromise.then(function (data){
                        console.info("save school diploma");  
                        $scope.forms.Diploma.$setPristine();

                        $scope.addGradPlanErrorOccurred = false;
                        
                        //spinner
                        $scope.isSearchBusy = false;
                        
                        return data;
                    }, function (error){
                        console.info('Error in saving school diploma....'.concat(angular.toJson(error)));   
                        $scope.addGradPlanErrorOccurred = true;
                        $scope.sameDiplomaNameError = true;

                        //spinner
                        $scope.isSearchBusy = false;
                        if (error.status == 400) {
                            for ( var j = 0; j < error.data._errors.length; j++) {
                                $scope.addGradPlanErrorMesg = $scope.addGradPlanErrorMesg + error.data._errors[j] + "\n" + "\n";
                            }
                        } else if (error.status == 401 || error.status == 403) {
                            $scope.addGradPlanErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                        } else {
                            $scope.addGradPlanErrorMesg = schoolwork12.app.errorMessages.internalError;
                        }
                        return error;
                    });
                    return saveSchoolDiplomaChain;
                };
                
                if (typeof (authentication.getCurrentUser()) != 'undefined' && authentication.getCurrentUser() != null) {
                    console.info('Keycode found. Making a call to service');
                    return saveSchoolDiplomaSvc();
                } else {
                    console.info('Key code not found. Using time out function to make a call');
                    $timeout(function () {
                        return saveSchoolDiplomaSvc();
                    }, 500);
                };
            };
            //-->
            
            //<!-- invoke rest service to save gradPlan
            $scope.saveGradPlan = function(diplomaId){
                var saveGradPlanPromise = null;
                $scope.addGradPlanErrorMesg = '';
                
                var saveGradPlanDiplomaSvc = function(){
                    var data = {
                        gradPlan: {termDetailList:[], yearDetailList:[], termsPerYear:parseInt($scope.termDetails.termspyr)}
                    };
                    
                    angular.forEach($scope.termDetails.terms, function(term,index1){
                        data.gradPlan.termDetailList.push({name: term.name, orderOfInsertion: index1+1, termMap:[], status: 1});
                        angular.forEach(term.termMapping, function(termMap, index2){
                            data.gradPlan.termDetailList[index1].termMap.push({schoolTermId: termMap.schoolTermId, schoolTermName: termMap.name, status: 1});
                        });
                    });
                    
                    angular.forEach($scope.yearPlans, function(plan, idx1){
                        data.gradPlan.yearDetailList.push({yearName: plan.name, cohortYearOffset: plan.Cohort, termCourseList: [], status: 1});
                        var index1 = data.gradPlan.yearDetailList.length-1;
                        angular.forEach(plan.terms, function(term, idx2){
                            data.gradPlan.yearDetailList[index1].termCourseList.push({
                                orderOfInsertion: index2+1,
                                name: $scope.termDetails.terms[idx2].name,
                                subjectToCourseList: [],
                                status: 1
                            });
                            var index2 = data.gradPlan.yearDetailList[index1].termCourseList.length-1;
                            
                            angular.forEach(term.items, function(item, idx3){
                                data.gradPlan.yearDetailList[index1].termCourseList[index2].subjectToCourseList.push({
                                    credits: item.creditRequired,
                                    status: 1
                                });
                                var index3 = data.gradPlan.yearDetailList[index1].termCourseList[index2].subjectToCourseList.length-1;
                                
                                if(angular.isDefined(item.course) && item.course!='' && item.course!=null){
                                    data.gradPlan.yearDetailList[index1].termCourseList[index2].subjectToCourseList[index3].id = item.course.id;
                                }
                                if(angular.isDefined(item.subject.schoolSubjectId)){
                                    data.gradPlan.yearDetailList[index1].termCourseList[index2].subjectToCourseList[index3].schoolSubjectId = item.subject.schoolSubjectId;
                                }
                                else if(angular.isDefined(item.subject.k12SubjectId)){
                                    data.gradPlan.yearDetailList[index1].termCourseList[index2].subjectToCourseList[index3].k12SubjectId = item.subject.k12SubjectId;
                                }
                            });
                            if(term.items.length == 0){
                                data.gradPlan.yearDetailList[index1].termCourseList.splice(index2,1);
                            }
                        });
                    });
                    
                    saveGradPlanPromise = graduationPlanSvc.saveGradPlan(authentication.getCurrentUser().keycode, diplomaId, data);  
                    var saveGradPlanChain = saveGradPlanPromise.then(function (data){
                        console.info("save GradPlan"); 
                        $scope.forms.GradPlan.$setPristine();

                        $scope.addGradPlanErrorOccurred = false;
                        
                        //spinner
                        $scope.isSearchBusy = false;
                        
                        return data;
                    }, function (error){
                        console.info('Error in saving GradPlan....'.concat(angular.toJson(error)));   
                        $scope.addGradPlanErrorOccurred = true;
                        //spinner
                        $scope.isSearchBusy = false;
                        if (error.status == 400) {
                            /*for ( var j = 0; j < error.data._errors.length; j++) {
                                $scope.addGradPlanErrorMesg = $scope.addGradPlanErrorMesg + error.data._errors[j] + "\n" + "\n";
                            }*/
                            //kickoff
                            $scope.showPartialWarningError();
                        } else if (error.status == 401 || error.status == 403) {
                            $scope.addGradPlanErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                        } else {
                            //$scope.addGradPlanErrorMesg = schoolwork12.app.errorMessages.internalError;
                            //kickoff
                            $scope.showPartialWarningError();
                        }
                        return error;
                    });
                    return saveGradPlanChain;
                };
                
                if (typeof (authentication.getCurrentUser()) != 'undefined' && authentication.getCurrentUser() != null) {
                    console.info('Keycode found. Making a call to service');
                    return saveGradPlanDiplomaSvc();
                } else {
                    console.info('Key code not found. Using time out function to make a call');
                    $timeout(function () {
                        return saveGradPlanDiplomaSvc();
                    }, 500);
                };
            };
            //-->
            
            //<!-- invoke rest service to save additional requirement
            $scope.saveAddRequirement = function(gradPlanId){
                var saveAddRequirementPromise = null;
                $scope.addGradPlanErrorMesg = '';
                var saveAddRequirementSvc = function(){
                    var gpAddReq = {addReqs: []};
                    angular.forEach($scope.additionReqs, function(req){
                        var obj = {gpARCategoryId: req.category.id, rename: req.rename, comments: req.comment, required: req.required, status: 1};
                        gpAddReq.addReqs.push(obj);
                    });
                    
                    var data = {gpAddReq: gpAddReq};
                    
                    saveAddRequirementPromise = graduationPlanSvc.saveAddRequirement(authentication.getCurrentUser().keycode, gradPlanId, data);
                    var saveAddRequirementChain = saveAddRequirementPromise.then(function (data){
                        console.info("save Additional Requirements");  
                        $scope.forms.AddRequirement.$setPristine();
                                     
                        $scope.addGradPlanErrorOccurred = false;
                        //spinner
                        $scope.isSearchBusy = false;
                        
                        return data;
                    }, function (error){
                        console.info('Error in saving Additional Requirements....'.concat(angular.toJson(error)));   
                        $scope.addGradPlanErrorOccurred = true;
                        //spinner
                        $scope.isSearchBusy = false;
                        if (error.status == 400) {
                            /*for ( var j = 0; j < error.data._errors.length; j++) {
                                $scope.addGradPlanErrorMesg = $scope.addGradPlanErrorMesg + error.data._errors[j] + "\n" + "\n";
                            }*/
                            //kickoff
                            $scope.showPartialWarningError();
                        } else if (error.status == 401 || error.status == 403) {
                            $scope.addGradPlanErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                        } else {
                            //$scope.addGradPlanErrorMesg = schoolwork12.app.errorMessages.internalError;
                            //kickoff
                            $scope.showPartialWarningError();
                        }
                        
                        return error;
                    });
                    
                    return saveAddRequirementChain;
                };
                
                if (typeof (authentication.getCurrentUser()) != 'undefined' && authentication.getCurrentUser() != null) {
                    console.info('Keycode found. Making a call to service');
                    return saveAddRequirementSvc();
                } else {
                    console.info('Key code not found. Using time out function to make a call');
                    $timeout(function () {
                        return saveAddRequirementSvc();
                    }, 500);
                };
            };
            //-->
            
             $scope.changeCourse = function(index1, index2, index3, course){
                 if($scope.yearPlans[index1].terms[index2].items[index3].course)
                    $scope.yearPlans[index1].terms[index2].items[index3].creditRequired = $scope.yearPlans[index1].terms[index2].items[index3].course.credits;
                 
                 if(course==null){
                    $scope.yearPlans[index1].terms[index2].items[index3].creditRequired = 0.0;
                 }
            }

            //<!-- save diploma, validation
            $scope.duplicateSubjectName = '';
            $scope.invalidCreditSubjectName = '';

            $scope.finish = function(){
                $scope.duplicateSubjCriteriaNames = [];
                $scope.mismatchedSubjCriteriaNames = [];
                $scope.duplicateSubjectAndSubjCriteriaNames = [];
                
                //diploma name is required
                if($scope.diplomaDetails.diplomaName == null || ($scope.diplomaDetails.diplomaName).trim()==''){
                    $scope.forms.Diploma.$setValidity('diplomaNameRequired', false);
                }
                else{
                    $scope.forms.Diploma.$setValidity('diplomaNameRequired', true);
                }
                
                var subjectSet = {};
                var duplicateSubject = false;
                var subjCriteriaSet = {};
                var duplicateSubjCriteria = false;
                var mismatchedSubjCriteria = false;
                var duplicateSubjectAndSubjCriteria = false;
                var invalidCredit = false;
                var subjectNotProvided = false;
                    
                //diplomaName cannnot contain wild card
                var diplomaName = $scope.diplomaDetails.diplomaName;
                if(diplomaName && (diplomaName.includes("%")||diplomaName.includes("_")||diplomaName.includes("*"))){
                    $scope.forms.Diploma.$setValidity('hasWildCard', false);
                }
                else{
                    $scope.forms.Diploma.$setValidity('hasWildCard', true);
                }
                
                //do not allow duplicate subjects in one diploma
                //credits must be valid
                angular.forEach($scope.gradReqs,function(subject){
                    if(subject.option){
                    }
                    else{
                        subjectNotProvided = true;
                    }
                    
                    if(subject.option && subjectSet[subject.option.name+'/'+subject.option.schoolSubjectId+'/'+subject.option.k12SubjectId]){
                        duplicateSubject = true;
                        $scope.duplicateSubjectName = subject.option.name;
                    }
                    
                    if(subject.option){
                        subjectSet[subject.option.name+'/'+subject.option.schoolSubjectId+'/'+subject.option.k12SubjectId] = 1;
                    }
                    
                    if(subject.credits != null && angular.isNumber(subject.credits)){
                        if(!(subject.credits<100.0&&subject.credits>=0.0)){
                            if(subject.option)
                                $scope.invalidCreditSubjectName = subject.option.name;
                            invalidCredit = true;
                        }
                    }
                    else{
                        if(subject.option)
                            $scope.invalidCreditSubjectName = subject.option.name;
                        invalidCredit = true;
                    }
                    
                    // Check Subject Criteria (1)
                    if(!subjectNotProvided && angular.isDefined(subject.subjectCriteria) && subject.subjectCriteria != null &&
                    		angular.isDefined(subject.subjectCriteria.subjectCriteriaList) && subject.subjectCriteria.subjectCriteriaList != null 
                    		&& subject.subjectCriteria.subjectCriteriaList.length > 0) {
                    	var subjCrtTotalCrdts = 0;
                    	var subjCrtOrCrdtsMatch = true;
                        var subCrtCond = 0; // 0:And, 1:Or
                        if (subject.subjectCriteria.logicalOperation == 'OR') {
                        	subCrtCond = 1;
                            console.info("*** Subject Criteria : " + subject.option.name + " uses OR");
                        } else {
                            console.info("*** Subject Criteria : " + subject.option.name + " uses AND");
                        }
                        
                        angular.forEach(subject.subjectCriteria.subjectCriteriaList, function(subjCriteria){
                        	// Note: each Subject Criteria has a name and credits (checked in the modal) 
                        	
                        	// Check: a subject may be used only once as Subject Criteria
                            if(subjCriteriaSet[subjCriteria.option.name+'/'+subjCriteria.option.schoolSubjectId+'/'+subjCriteria.option.k12SubjectId]){
                            	duplicateSubjCriteria = true;
                                $scope.duplicateSubjCriteriaNames.push(subjCriteria.option.name);
                                console.info("Duplicate subject criteria: " + subjCriteria.option.name);
                            }
                            subjCriteriaSet[subjCriteria.option.name+'/'+subjCriteria.option.schoolSubjectId+'/'+subjCriteria.option.k12SubjectId] = 1;
                            
                            // Check: Subject Criteria must total up/match the parent subject
                            if (subCrtCond == 0) {
                            	subjCrtTotalCrdts += subjCriteria.credits;
                            } else {
                            	if (subject.credits != subjCriteria.credits) {
                            		subjCrtOrCrdtsMatch = false;
                            	}
                            }
                        });
                        
                        if(subCrtCond == 0) {
                        	if (subjCrtTotalCrdts != subject.credits) {
                        		mismatchedSubjCriteria = true;
                        		$scope.mismatchedSubjCriteriaNames.push(subject.option.name); // Err msg is on the parent subject (not the Subject Criteria item)
                                console.info("Mismatched on AND for subject: " + subject.option.name);
                        	}
                        } else {
                        	if (!subjCrtOrCrdtsMatch) {
                        		mismatchedSubjCriteria = true;
                        		$scope.mismatchedSubjCriteriaNames.push(subject.option.name); // Err msg is on the parent subject (not the Subject Criteria item)
                                console.info("Mismatched on OR for subject: " + subject.option.name);
                        	}
                        }
                    }       
                                         
                });
                
                // Check Subject Criteria (2)
                angular.forEach($scope.gradReqs,function(subject){
                    if(subject.option && subjCriteriaSet[subject.option.name+'/'+subject.option.schoolSubjectId+'/'+subject.option.k12SubjectId]){
                        // Subject is also used as a Subject Criteria
                        // Make sure it appears under its own Subject Criteria
                        if(angular.isDefined(subject.subjectCriteria) && subject.subjectCriteria != null &&
                    		angular.isDefined(subject.subjectCriteria.subjectCriteriaList) && subject.subjectCriteria.subjectCriteriaList != null 
                    		&& subject.subjectCriteria.subjectCriteriaList.length > 0) {
                            
                            var isItsOwnChild = false;
                            angular.forEach(subject.subjectCriteria.subjectCriteriaList, function(subjCriteria){

                                if(subjCriteria.option.name == subject.option.name && subjCriteria.option.schoolSubjectId == subject.option.schoolSubjectId
                                    && subjCriteria.option.k12SubjectId == subject.option.k12SubjectId) {
                                    isItsOwnChild = true;
                                }                                                   
                            });
                            
                            if(!isItsOwnChild) {
                                duplicateSubjectAndSubjCriteria = true;
                                $scope.duplicateSubjectAndSubjCriteriaNames.push(subject.option.name);
                                console.info("Duplicate Subject and Subject Criteria (1): " + subject.option.name);
                            }
                            
                        } else {
                            duplicateSubjectAndSubjCriteria = true;
                            $scope.duplicateSubjectAndSubjCriteriaNames.push(subject.option.name);
                            console.info("Duplicate Subject and Subject Criteria (2): " + subject.option.name);
                        }
                        
                    }
                });
                
                $scope.forms.Diploma.$setValidity('subjectRequired', subjectNotProvided ? false : true);
                $scope.forms.Diploma.$setValidity('duplicateSubject', duplicateSubject ? false : true);
                $scope.forms.Diploma.$setValidity('invalidCredit', invalidCredit ? false : true);

                $scope.forms.Diploma.$setValidity('duplicateSubjCriteria', duplicateSubjCriteria ? false : true);
                $scope.forms.Diploma.$setValidity('mismatchedSubjCriteria', mismatchedSubjCriteria ? false : true);
                $scope.forms.Diploma.$setValidity('duplicateSubjectAndSubjCriteria', duplicateSubjectAndSubjCriteria ? false : true);

                //validation for 4year Plan
                if($scope.forms.GradPlan.$dirty || $scope.forms.AddRequirement.$dirty){
                        angular.forEach($scope.termDetails.terms,function(term,index){
                        if(term.name==null||(term.name).trim()==''){
                            $scope.forms.GradPlan['termName_'+index].$setValidity('termNameRequired',false);
                        }
                        else{
                            $scope.forms.GradPlan['termName_'+index].$setValidity('termNameRequired',true);
                        }

                        if(!angular.isDefined(term.termMapping)||term.termMapping == null|| term.termMapping.length == 0){
                            $scope.forms.GradPlan['termName_'+index].$setValidity('schoolMapRequired',false);
                        }
                        else{
                            $scope.forms.GradPlan['termName_'+index].$setValidity('schoolMapRequired',true);
                        }
                    });

                    var cohortSet = {};
                    var courseSet = {};
                        
                    angular.forEach($scope.yearPlans,function(plan){
                        if(plan.name == '' || plan.name == null){
                            $scope.forms.GradPlan['yearPlan_'+plan.index].$setValidity('yearNameRequired',false);
                        }
                        else{
                            $scope.forms.GradPlan['yearPlan_'+plan.index].$setValidity('yearNameRequired',true);
                        }

                        if(cohortSet[plan.Cohort]==1){
                            $scope.forms.GradPlan['yearPlan_'+plan.index].$setValidity('duplicateCohort',false);
                        }
                        else{
                            $scope.forms.GradPlan['yearPlan_'+plan.index].$setValidity('duplicateCohort',true);
                            cohortSet[plan.Cohort] = 1;
                        }

                        angular.forEach(plan.terms,function(term){
                            angular.forEach(term.items,function(item){
                                if(item.subject == '' || item.subject == null){              
                                    $scope.forms.GradPlan['subject_'+plan.index+'_'+term.index+'_'+item.index].$setValidity('subjectRequired',false);
                                }
                                else{
                                    $scope.forms.GradPlan['subject_'+plan.index+'_'+term.index+'_'+item.index].$setValidity('subjectRequired',true);
                                }

                                if(item.creditRequired != null && angular.isNumber(item.creditRequired)){
                                    if((!(item.creditRequired<100.0&&item.creditRequired>=0.0))){
                                        $scope.forms.GradPlan['credit_'+plan.index+'_'+term.index+'_'+item.index].$setValidity('invalidCredit',false);
                                    }
                                    else{
                                        $scope.forms.GradPlan['credit_'+plan.index+'_'+term.index+'_'+item.index].$setValidity('invalidCredit',true);
                                    }
                                }
                                else{
                                    $scope.forms.GradPlan['credit_'+plan.index+'_'+term.index+'_'+item.index].$setValidity('invalidCredit',false);
                                }

                                if(angular.isDefined(item.course) && item.course!='' && item.course!=null){
                                    if(courseSet[''+item.course.id]==1){
                                        $scope.forms.GradPlan['course_'+plan.index+'_'+term.index+'_'+item.index].$setValidity('duplicateCourse',false);
                                    }
                                    else{
                                        courseSet[''+item.course.id]=1
                                        $scope.forms.GradPlan['course_'+plan.index+'_'+term.index+'_'+item.index].$setValidity('duplicateCourse',true);
                                    }
                                }
                                else{
                                    $scope.forms.GradPlan['course_'+plan.index+'_'+term.index+'_'+item.index].$setValidity('duplicateCourse',true);
                                }

                            });
                        });
                    });
                }
                
               
                //validation for additional requirement
                if($scope.forms.AddRequirement.$dirty){
                    var renameSet = {}
                    angular.forEach($scope.additionReqs, function(req){
                        $scope.forms.AddRequirement['category_'+req.index].$setValidity('categoryRequired', req.category==null||req.category=='' ? false : true);
                        $scope.forms.AddRequirement['rename_'+req.index].$setValidity('renameRequired', req.rename==''||req.rename==null ? false : true);
                        if(req.rename!=null && renameSet[req.rename.toLowerCase()] == 1){
                            $scope.forms.AddRequirement['rename_'+req.index].$setValidity('duplicateRename', false);
                        }
                        else if(req.rename!=null && req.rename != ''){
                            renameSet[req.rename.toLowerCase()] = 1;
                            $scope.forms.AddRequirement['rename_'+req.index].$setValidity('duplicateRename', true);
                        }
                    });
                }

                //add error styles based on validation flags
                $scope.validateDiploma = !$scope.forms.Diploma.$valid ? true : false;
                $scope.validateGradPlan = !$scope.forms.GradPlan.$valid ? true : false;
                $scope.validateAddReq = !$scope.forms.AddRequirement.$valid ? true : false;
                
                //save diploma and grad plan only when both are valid or save diploma only when step 1 is valid
                if(($scope.forms.Diploma.$valid && $scope.forms.GradPlan.$valid && $scope.forms.AddRequirement.$valid)){
                    $scope.isSearchBusy = true;
                    var saveSchoolDiplomaChain = $scope.saveSchoolDiploma();
                    
                    saveSchoolDiplomaChain.then(function(data){
                        //when promise finished successfully, no data.status(not even 200) will be return 
                        if(angular.isUndefined(data.status) && $scope.forms.GradPlan.$dirty){
                            //save gradplan
                            var diplomaId = data.split("id: ")[1].split(' ')[0];
                            $scope.isSearchBusy = true;
                            var saveGradPlanChain = $scope.saveGradPlan(diplomaId);

                            saveGradPlanChain.then(function (data){
                                if(angular.isUndefined(data.status) && $scope.forms.AddRequirement.$dirty && $scope.additionReqs.length!=0){
                                    var gradPlanId = data.split("id ")[1].split(' ')[0];
                                    $scope.isSearchBusy = true;
                                    var saveAddRequirementChain = $scope.saveAddRequirement(gradPlanId);
                                    saveAddRequirementChain.then(function(data){
                                        if(angular.isUndefined(data.status)){
                                            $rootScope.showSavedSuccessMsg = true;
                                            $rootScope.closeSuccess = false;
                                            $location.url('/manage-school-graduation-plans');
                                        }
                                    });
                                }
                                else if(angular.isUndefined(data.status)){
                                    if(!$scope.forms.AddRequirement.$dirty || $scope.additionReqs.length==0){
                                        $scope.forms.AddRequirement.$setPristine();
                                        $rootScope.showSavedSuccessMsg = true;
                                        $rootScope.closeSuccess = false;
                                        $location.url('/manage-school-graduation-plans');
                                    }
                                }
                                
                            });
                        }
                        else if(angular.isUndefined(data.status)){
                            //do not save gradplan
                            if(!$scope.forms.GradPlan.$dirty){
                                $rootScope.showSavedSuccessMsg = true;
                                $rootScope.closeSuccess = false;
                                $location.url('/manage-school-graduation-plans');
                            }
                        }
                    });
                }
                
                // console.log($scope.forms.GradPlan);
                //console.log($scope.termDetails);
                //console.log($scope.forms.AddRequirement);
            }
           
 
    }]);
 
    
}(angular, schoolwork12));